export default __webpack_public_path__ + "static/media/Version (2) - Prisoner of Azkaban_11.9c26ecd5.jpg";